import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Config from "src/Constants/Config";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";

const PageId = 6;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const [step, setStep] = useState(0);

  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_1 = `${baseImageUrl}animation_1.png`;
  const rightSideImage_2 = `${baseImageUrl}animation_2.png`;

  const rightSideComponentBaseStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    bottom: 0,
    transition: "opacity .6s ease-in-out",
    height: "100%",
  };

  useEffect(() => {
    let timeoutId: any;
    if (currentPage === PageId) {
      if (step === 0) timeoutId = setTimeout(() => setStep(step + 1), 200);
    } else setStep(0);

    return () => {
      setStep(0);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const stepsTime = [400, 400, 400];

  useEffect(() => {
    let timeoutId: any;
    if (step > 0 && step <= stepsTime.length) timeoutId = setTimeout(() => setStep(step + 1), stepsTime[step - 1]);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    gradient: "linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 57%, rgba(255, 255, 255, 0.00) 100%)",
    title: "Understand your network usage\nlike never before",
    description: `The Infosys Connectivity Platform provides\npersonalized insights into your home’s internet\nusage, helping you stay in control and optimize\nperformance effortlessly.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`<ul><li>Real-Time Data – See live network activity,\ndevice usage, and bandwidth distribution.</li>\n<li>Usage Trends – Get daily, weekly, and monthly\nreports on internet consumption.</li>\n<li>Smart Recommendations – AI-powered insights\nsuggest ways to optimize performance and\nreduce congestion.</li></ul>`}
      />
    ),
    rightSideComponent: (
      <>
        <img src={rightSideImage_1} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 1 ? 1 : 0 }} />
        <img src={rightSideImage_2} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 2 ? 1 : 0 }} />
        {step >= 2 && (
          <video
            autoPlay
            loop
            muted
            style={{
              ...rightSideComponentBaseStyle,
              width: "var(--width-390)",
              top: "var(--height-118)",
              right: "var(--width-120)",
              height: "var(--width-844)",
              borderRadius: "var(--width-55)",
            }}
            src={Config.BASE_URL + "/videos/screen_6.mp4"}
          />
        )}
      </>
    ),
    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
